module.exports = __webpack_public_path__ + "img/four_zhTc.9cad3818.png";